import { EUnitsOfDistance } from '../../types';
import { RootState } from '../store';

import { AppState } from './app.slice';

export const selectAppState = (state: RootState): AppState => state.appReducer;
export const selectUnitsOfDistance = (state: RootState): EUnitsOfDistance =>
    state.appReducer.unitsOfDistance ?? EUnitsOfDistance.KILOMETERS;
export const selectDrawerSnapPoint = (state: RootState): number | string | null =>
    state.appReducer.drawerSnapPoint;
